import PropTypes from 'prop-types';
import currencyExchangeProp from './currencyExchangeProp';

export const WALLET_TYPE = {
  FIAT: 'fiat',
  CRYPTO: 'crypto',
  COINS: 'coins',
  COUPONS: 'coupons',
  VOUCHERS: 'vouchers',
};

export const CRYPTO_FARM = {
  HASH_RATE: 'hashrate',
  MINERS_ONLINE: 'minersOnline',
  POWER_USAGE: 'powerUsage',
  MINERS_TOTAL: 'minersTotal',
};

export const CRYPTO_FARM_ORDER = {
  hashrate: 0,
  minersOnline: 1,
  powerUsage: 2,
  minersTotal: 3,
};

const propType = {
  type: PropTypes.oneOf(Object.values(WALLET_TYPE)).isRequired,
  currency: PropTypes.string,
  balance: PropTypes.string,
  available: PropTypes.string,
  totalPayouts: PropTypes.string,
  totalPayments: PropTypes.string,
  userPriceBalance: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(currencyExchangeProp.propType),
  ]),
  userPriceAvailable: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(currencyExchangeProp.propType),
  ]),
  currencyInfo: PropTypes.shape({
    name: PropTypes.string,
    symbol: PropTypes.string,
    symbol_native: PropTypes.string,
    icon: PropTypes.string,
  }),
};

export default { propType };
